import { render, staticRenderFns } from "./ActionPremiumRating.vue?vue&type=template&id=062ea240&scoped=true&"
import script from "./ActionPremiumRating.vue?vue&type=script&lang=js&"
export * from "./ActionPremiumRating.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "062ea240",
  null
  
)

export default component.exports